import { createAction } from 'redux-actions';

export const showAlert = createAction('SHOW_ALERT');
